// API service for DoubleTap Innovations
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const signupForWaitlist = async (email) => {
  try {
    const response = await fetch(`${API_BASE}/signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      // Handle specific error cases
      if (response.status === 409) {
        throw new Error('Email already registered for waitlist');
      } else if (response.status === 400) {
        throw new Error('Invalid email address');
      } else {
        throw new Error(data.detail || 'Something went wrong. Please try again.');
      }
    }

    return data;
  } catch (error) {
    // Handle network errors or other issues
    if (error.message.includes('fetch')) {
      throw new Error('Network error. Please check your connection and try again.');
    }
    throw error;
  }
};

export const getSignups = async () => {
  try {
    const response = await fetch(`${API_BASE}/signups`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch signups');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching signups:', error);
    throw error;
  }
};